import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import KanbanProjectCard from "./KanbanProjectCard";
import { KanbanBoardItem } from "./kanbanTypes";

interface KanbanColumnProps {
  label: string;
  color: string;
  items: KanbanBoardItem[];
}

/**
 * A single read-only column in the Kanban board representing one overview status.
 */
const KanbanColumn = ({ label, color, items }: KanbanColumnProps) => {
  const totalBT = items.reduce((sum, item) => sum + (item.metricValue ?? 0), 0);

  return (
    <Paper
      sx={{
        minWidth: 220,
        width: 220,
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        bgcolor: "background.default",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        maxHeight: "calc(100vh - 280px)",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          p: 1.5,
          borderBottom: "3px solid",
          borderColor: color,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="subtitle2" fontWeight="bold" noWrap>
            {label}
          </Typography>
          <Typography variant="caption" color="text.secondary" noWrap>
            {items.length} {items.length === 1 ? "Eintrag" : "Einträge"}
            {totalBT > 0 ? ` · ${totalBT} BT` : ""}
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          p: 1,
          overflowY: "auto",
          overflowX: "hidden",
          flex: 1,
        }}
      >
        {items.map((item) => (
          <KanbanProjectCard key={item.id} item={item} />
        ))}
        {items.length === 0 && (
          <Typography variant="caption" color="text.secondary" sx={{ p: 1, display: "block", textAlign: "center" }}>
            Keine Einträge
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default KanbanColumn;
